import React from "react";
import ReactDom from "react-dom";
import SystemsCatalog from "./common";

const { filter, systems } = window.__PRELOAD_CATALOG__ || { filter: null, systems: null };

const container = document.getElementById("catalog-wrapper");

if (container) ReactDom.render(<SystemsCatalog filter={filter} systems={systems} />, container);